"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NoVisualization = void 0;
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../../../Framework/i18n");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var styles = {
  root: {
    paddingTop: 200,
    textAlign: 'center'
  }
};
var NoVisualization = exports.NoVisualization = (0, _styles.withStyles)(styles, {
  name: 'NoVisualization'
})(function (_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    className: classes.root
  }, (0, _i18n.T)('visualization.errors.visualizationNotPossible'));
});
var _default = exports["default"] = NoVisualization;